import React from 'react';
import Hero from './components/IQAC/consultancy-cell/Hero';
import Main from './components/IQAC/consultancy-cell/Main';

const IqacIndustryConsultancyCell = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default IqacIndustryConsultancyCell;